import { render } from "./Second.vue?vue&type=template&id=71df9e68&ts=true"
import script from "./Second.vue?vue&type=script&lang=ts"
export * from "./Second.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__